import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import DocumentPreview from './DocumentPreview';
import { API_BASE_URL } from '../services/legistarApi';

const DocumentPage: React.FC = () => {
  const params = useParams();
  const { eventId, matterId, attachmentId, documentName } = params;
  const [documentTitle, setDocumentTitle] = useState<string>('');

  // Decode the document name from URL
  useEffect(() => {
    if (documentName) {
      setDocumentTitle(decodeURIComponent(documentName));
    }
  }, [documentName]);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="mb-4">
          <Link
            to={eventId ? `/event/${eventId}` : `/legislation/${matterId}`}
            className="text-nyc-orange hover:underline"
          >
            &larr; {eventId ? 'Back to Event' : 'Back to Legislation'}
          </Link>
        </div>
        <h1 className="text-3xl font-bold text-nyc-blue mb-6">{documentTitle || 'Document'}</h1>
        
        <div className="mb-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-nyc-blue">Document Preview</h2>
            <a
              href={`${API_BASE_URL}/matters/${matterId}/attachments/${attachmentId}/file`}
              className="px-4 py-2 bg-nyc-orange text-white rounded-md hover:bg-orange-600 transition-colors flex items-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Download
            </a>
          </div>
          <DocumentPreview 
            url={`${API_BASE_URL}/matters/${matterId}/attachments/${attachmentId}/file`}
            name={documentTitle || 'Document'}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentPage; 